import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useMobileDetection } from '../hook/useMobileDetection';
import { useTranslation } from 'react-i18next'

import { useContext, useEffect, useState } from 'react';
import { formatter } from '../resources/funciones';
import { MdArrowBackIosNew, MdArrowForwardIos } from "react-icons/md"
import { ContadorProducto } from './ContadorProducto';
import { CarritoContext } from '../context/CarritoContext';
import { ProductoContext } from '../context/ProductoContext';

import Swal from 'sweetalert2'

import Markdown from 'react-markdown'

export const ProductoDescripcion = () => {

    const { t, i18n } = useTranslation()
    const { aniadirProducto,aniadirPack, setMostrarCarrito } = useContext(CarritoContext)
    const { listaProductos } = useContext(ProductoContext)

    const isMobile = useMobileDetection();
    const location = useLocation()
    const idProducto = Number(location.pathname.split('/').pop())

    const [producto, setProducto] = useState({})
    const [existeProducto, setExisteProducto] = useState(false)

    const [contador, setContador] = useState(1)

    /* useEffect(()=>{console.log(producto)},[producto]) */

    let colorPrev = "#365865"
    let colorNext = "#365865"
    
    const indice = listaProductos.findIndex(p => p?.ProdCod === idProducto);

    let productoAnterior = {};
    let productoPosterior = {}
    if (indice > 0) {
        productoAnterior = listaProductos[indice - 1];
    } else {
        productoAnterior = listaProductos[0]
        colorPrev = "#808B96"
    }

    if (indice < listaProductos.length - 1) {
        productoPosterior = listaProductos[indice + 1];
    } else {
        productoPosterior = listaProductos[indice]
        colorNext = "#808B96"
    }

    const openImagen = (url) => {
        
        Swal.fire({
            width:"max-content",            
            html:`
            <div class="container">
                <img src="${url}" class="img-fade-linear" style="width:60vw"></img>
            </div>
            `,
            showConfirmButton:false,
            showCloseButton:true
        })
    }

    const navigate = useNavigate()

    const realizarCompra = (producto, contador) => {
        aniadirProducto(producto, contador)
        navigate("/carrito")
        setMostrarCarrito(false)
    }

    useEffect(() => {
        
        const productoEncontrado = listaProductos.find(p => p?.ProdCod === idProducto)
        if (!productoEncontrado) {
            setProducto({})
            setExisteProducto(false)
        } else {
            setProducto(productoEncontrado)
            setExisteProducto(true)
        }
        // eslint-disable-next-line
    }, [productoAnterior, productoPosterior])    

    return (
        <div>
            <div className="container" style={{paddingTop:"94px"}}>
                <div className="row" >
                    <div aria-label="breadcrumb" className="col-md-9 mt-3">
                        <ol className="breadcrumb text-md-start text-center">
                            <Link className="breadcrumb-item" to={`/inicio`} style={{ color: "#365865" }}>{t("tienda_nav_inicio")}</Link>
                            <Link className="breadcrumb-item" to={`/tienda`} style={{ color: "#365865" }}>{t("tienda_nav_tienda")}</Link>
                            <Link className="breadcrumb-item active" aria-current="page">{producto?.ProdNom}</Link>
                        </ol>
                    </div>
                    <div className="col-md-3 mt-3 text-md-end text-center">
                        <div className={`mb-1 d-flex align-items-center ${isMobile ? "justify-content-center" : "justify-content-end"}`}>
                            <Link className={`me-2`} to={`/producto/${productoAnterior?.ProdCod}`} style={{ color: colorPrev, pointerEvents: indice === 0 ? "none" : "", display: "flex", alignItems: "center" }}><MdArrowBackIosNew />{t("tienda_nav_previo")}</Link>
                            |
                            <Link className={`ms-2 active`} to={`/producto/${productoPosterior?.ProdCod}`} style={{ color: colorNext, pointerEvents: indice === listaProductos.length - 1 ? "none" : "", display: "flex", alignItems: "center" }}>{t("tienda_nav_proximo")} <MdArrowForwardIos /></Link>
                        </div>

                    </div>
                </div>
            </div>

            <div className="container" style={{ minHeight: isMobile ? "auto" : "calc(100vh - 161px)" }}>
                {
                    existeProducto ? (
                        <>
                            <div className="row" style={{ minHeight: isMobile ? "auto" : "calc(100vh - 161px)" }}>
                                <div className="col-12 col-md-6 mb-2 position-relative overflow-hidden" >                                    
                                    <div className="d-flex justify-content-center" data-mdb-ripple-color="light" >
                                        <img className="img-fade-linear product-image" src={producto?.ProdImg} alt='producto' onClick={() => openImagen(producto?.ProdImgBig)} style={{ cursor: 'pointer' }} />
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <h5 className="text-start mt-1" style={{ fontSize: "32px" }}>{producto?.ProdNom}</h5>
                                    {producto?.ProdNue && (
                                        <div className='text-primario fw-bold'>{t("tienda_producto_msg_nuevo")}</div>
                                    )}
                                    {i18n.resolvedLanguage === "es" && <h6 className="text-start mt-3">
                                        {
                                            (!producto?.ProdPrecD) ? (
                                                <strong style={{ fontSize: "24px", color: "#052F3E" }}>{formatter.format(producto?.ProdPrecN)}</strong>
                                            ) : (
                                                <>
                                                    <s style={{ fontSize: "18px", color: "rgb(128,128,128)" }}>{formatter.format(producto?.ProdPrecN)}</s>
                                                    <strong className="ms-2" style={{ fontSize: "24px", color: "#052F3E" }}>{formatter.format(producto?.ProdPrecD)}</strong>
                                                </>
                                            )
                                        }


                                    </h6>}
                                    {i18n.resolvedLanguage === "es" && <div className="info-cantidad mt-3">                                        
                                        <div className="mt-3">
                                            <ContadorProducto idProducto={idProducto} contador={contador} aumentarCallback={()=>setContador(contador+1)} disminuirCallback={()=>setContador(contador-1)} resetCallback={()=>setContador(1)} />
                                        </div>
                                    </div>}
                                    
                                    {i18n.resolvedLanguage === "es" && <div className="botones-comprar mt-4">
                                        <button type="button" className="btn btn-primario w-100 text-white" onClick={() =>producto.ProdPack? aniadirPack(producto,contador):aniadirProducto(producto, contador)}>Agregar al carrito</button>
                                        {! producto.ProdPack && <button type="button" className="btn btn-secundario w-100 text-white" onClick={() => realizarCompra(producto, contador)}>Realizar compra</button>}
                                    </div>}
                                    <div className="info-descripcion">
                                        <div className="mt-3 fw-bold" style={{color:"var(--color-terciario)"}}>{t("tienda_producto_cabecera")}:</div>
                                        <div className='markdown fs-4'><Markdown>{producto?.ProdDes}</Markdown></div>                                        
                                    </div>
                                </div>
                            </div>                            
                        </>
                    ) : (
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <h2>No hay producto</h2>
                        </div>
                    )
                }

            </div>            
        </div>
    )
}
